import {mutationRequest} from "./makePostRequest";

export const mutationGetUserLogin = (body) => mutationRequest('getUserLogin', `getUserLogin`, body);
// export const mutationGetUserLogin = (body) => mutationRequest('getUserLogin', `getUserLogin?email_id=${body?.email_id}&password=${body?.password}`, body);

export default mutationGetUserLogin;
